import { call, put, select } from 'redux-saga/effects';
import { availabilityService } from '../services/availabilityService';
import { availabilityConstants } from '../actions/constants/availabilityConstants';

function* fetchAvailability(action: any): any {
  try {
    const response = yield call(availabilityService.fetchAvailability, action.payload);
    if (response && response.success) {
      yield put({ type: availabilityConstants.fetchAvailabilitySuccess, payload: { availability: response.resultObject.availability || {}, raw: response.resultObject.raw || [] } });
    } else {
      yield put({ type: availabilityConstants.fetchAvailabilityFailure, payload: response?.message || response });
    }
  } catch (error: any) {
    yield put({ type: availabilityConstants.fetchAvailabilityFailure, payload: error });
  }
}

function* updateAvailability(action: any): any {
  try {
    const state = yield select();
    const photographerId = action.payload?.photographerId || state.authReducer?.authData?.id;
    let entries: any[] = [];
    
    if (action.payload && Array.isArray(action.payload.entries)) {
      entries = action.payload.entries;
    } else {
      const map = state.availability?.availabilityMap || {};
      const localReasons = state.availability?.localReasons || {};

      for (const date of Object.keys(map)) {
        const day = map[date];
        
        const morningKey = `${date}|MORNING`;
        const eveningKey = `${date}|EVENING`;
        const morningReason = localReasons[morningKey] || null;
        const eveningReason = localReasons[eveningKey] || null;

        entries.push({ 
          date, 
          session: 'MORNING', 
          isAvailable: day.MORNING !== false,
          reason: day.MORNING === false ? morningReason : null 
        });

        entries.push({ 
          date, 
          session: 'EVENING', 
          isAvailable: day.EVENING !== false,
          reason: day.EVENING === false ? eveningReason : null
        });
      }
    }
    
    const payload = { photographerId, entries };
    const response = yield call(availabilityService.updateAvailability, payload);
    if (response && response.success) {
      yield put({ type: availabilityConstants.updateAvailabilitySuccess, payload: response.resultObject || response });
      try {
        const now = new Date();
        const start = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-01`;
        const end = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(new Date(now.getFullYear(), now.getMonth()+1,0).getDate()).padStart(2,'0')}`;
        yield put({ type: availabilityConstants.fetchAvailabilityRequest, payload: { photographerId, startDate: start, endDate: end } });
      } catch (e) {}
    } else {
      yield put({ type: availabilityConstants.updateAvailabilityFailure, payload: response?.message || response });
    }
  } catch (error: any) {
    yield put({ type: availabilityConstants.updateAvailabilityFailure, payload: error });
  }
}

export const availabilitySaga = {
  fetchAvailability,
  updateAvailability,
};
